import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Alert, Box, Link, Typography, FormHelperText } from '@mui/material'
import { ReactComponent as Warning } from '../../../assets/icons/warning.svg'

import useTranslations from '../../../i18n/useTranslations'
import { makeFormPropTypes } from '../../../common/formikPropTypes'
import { shippingSendCustomShipmentPropTypes } from '../../../common/propTypes'

import FormLayout from './FormLayout'
import useStyles from './styles'
import Loader from '../Loader'
import InfoCustoms from './StepCustoms/InfoCustoms'
import InventoryCustom from './StepCustoms/InventoryCustom'
import Checkbox from '../../components/checkbox'
import { useState } from 'react'
import FileUploader from '../../components/FileUploader/FileUploader'
import NormativeModal from '../../modals/normative'

const StepCustoms = ({
  values,
  destinCountryCode,
  originCountryCode,
  fieldErrors,
  formErrors,
  touched,
  onChange,
  onBlur,
  isLoadingServiceTypeOptions,
  hasCustoms,
  allowsElectronicalTradeDocuments,
  handleRemoveItem,
  handleAddItem,
  centreCode,
  handleRemoveDocument,
  handleAddDocument,
  handleChangeDocument,
}) => {
  const t = useTranslations()
  const classes = useStyles()
  const [openModal, setOpenModal] = useState(false)

  const acceptedFileTypes =
    '.doc, .docx, .xls, .xlsx, .txt, .rtf, .jpg, .gif, .bmp, .tif, .png, .pdf'

  const openRequiredDocsPdf = async () => {
    // NOTE: solución temporal. En el futuro, el PDF será alojado en un servidor
    // o será accesible vía API.
    const document = await fetch(
      process.env.PUBLIC_URL +
        '/documents/Documentacion_necesaria_envios_internacionales.pdf',
    )
    const blob = await document.blob()
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank')
  }

  const openCustomsPdf = async () => {
    // NOTE: solución temporal. En el futuro, el PDF será alojado en un servidor
    // o será accesible vía API.
    const document = await fetch(
      process.env.PUBLIC_URL +
        '/documents/DOCUMENTO_ADUANAS_CTT(Formulario).pdf',
    )
    const blob = await document.blob()
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank')
  }

  const openInventorySheetPdf = async () => {
    // NOTE: solución temporal. En el futuro, el PDF será alojado en un servidor
    // o será accesible vía API.
    const document = await fetch(
      process.env.PUBLIC_URL + '/documents/Hoja adicional inventario.pdf',
    )
    const blob = await document.blob()
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank')
  }
  return (
    <FormLayout>
      {isLoadingServiceTypeOptions ? (
        <Loader />
      ) : (
        <>
          <NormativeModal
            onClose={() => setOpenModal(false)}
            isOpen={openModal}
          />
          <Typography
            variant="h2"
            className={clsx('secondaryTitle', 'decorator', classes.title)}
          >
            {t('shipping-send-form:customs:title')}
          </Typography>
          {!hasCustoms ? (
            <Alert
              iconMapping={{
                warning: <Warning />,
              }}
              severity="success"
              className={classes.tooltipCenter}
            >
              <Typography variant="h3" sx={{ marginBottom: 1 }}>
                {t('shipping-send-form:customs:no-necessary')}
              </Typography>
              <Typography>
                {t('shipping-send-form:customs:no-necessary-body')}
              </Typography>
            </Alert>
          ) : (
            <Typography className={classes.tooltipCenter}>
              {t('shipping-send-form:customs:info')}
            </Typography>
          )}
          {hasCustoms ? (
            <>
              <Box component="section" className={classes.row}>
                <Box component="section" className={classes.sectionRowSender}>
                  <InfoCustoms
                    id={'sender'}
                    values={values}
                    originCountryCode={originCountryCode}
                    destinCountryCode={destinCountryCode}
                    touched={touched}
                    fieldErrors={fieldErrors}
                    formErrors={formErrors}
                    onChange={onChange}
                    onBlur={onBlur}
                  />
                </Box>

                <Box component="section" className={classes.sectionRowReceptor}>
                  <InfoCustoms
                    id={'receptor'}
                    values={values}
                    originCountryCode={originCountryCode}
                    destinCountryCode={destinCountryCode}
                    touched={touched}
                    fieldErrors={fieldErrors}
                    formErrors={formErrors}
                    onChange={onChange}
                    onBlur={onBlur}
                  />
                </Box>
              </Box>
              <Box component="section" className={classes.row}>
                <InventoryCustom
                  id={'receptor'}
                  values={values}
                  originCountryCode={originCountryCode}
                  destinCountryCode={destinCountryCode}
                  touched={touched}
                  fieldErrors={fieldErrors}
                  formErrors={formErrors}
                  handleAddItem={handleAddItem}
                  handleRemoveItem={handleRemoveItem}
                  onChange={onChange}
                  onBlur={onBlur}
                />
              </Box>
              {/*Quitar cuando allowsElectronicalTradeDocuments tenga efecto*/}
              {!allowsElectronicalTradeDocuments && false ? (
                <Box component="section" className={classes.row}>
                  <Typography
                    variant="h2"
                    className={clsx(
                      'secondaryTitle',
                      'decorator',
                      classes.title,
                    )}
                  >
                    {t('shipping-send-form:keep-in-mind')}
                  </Typography>
                  <Alert severity="info" className={classes.alert}>
                    <Typography variant="body2">
                      {t('shipping-send-form:customs-documentation-text', {
                        invoiceModel: (
                          <Link
                            onClick={openCustomsPdf}
                            style={{ color: 'red' }}
                          >
                            {t('shipping-send-form:invoice-model')}
                          </Link>
                        ),
                        instructions: (
                          <Link
                            onClick={openRequiredDocsPdf}
                            style={{ color: 'red' }}
                          >
                            {t('shipping-send-form:instructions')}
                          </Link>
                        ),
                        inventorySheet: (
                          <Link
                            onClick={openInventorySheetPdf}
                            style={{ color: 'red' }}
                          >
                            {t('shipping-send-form:inventory-sheet')}
                          </Link>
                        ),
                      })}
                    </Typography>
                  </Alert>
                </Box>
              ) : (
                <Box component="section" className={classes.row}>
                  <Typography
                    variant="h2"
                    className={clsx(
                      'secondaryTitle',
                      'decorator',
                      classes.title,
                    )}
                  >
                    {t('shipping-send-form:customs:additional')}
                  </Typography>
                  <Typography sx={{ marginBottom: 5 }}>
                    {t('shipping-send-form:customs:upload-files')}
                  </Typography>

                  <FileUploader
                    centreCode={centreCode}
                    onAdd={handleAddDocument}
                    onDelete={handleRemoveDocument}
                    onChange={handleChangeDocument}
                    acceptFiles={acceptedFileTypes}
                    initialFiles={values?.additionalDocumentation}
                    maxFiles={4}
                  />
                </Box>
              )}

              <Box component="section" className={classes.sectionColumn}>
              {(!values.authorized || !values.readed) && touched.wasSubmit ? (
                  <FormHelperText className={classes.helperText}>
                    {t('error:field:conditions-required')}
                  </FormHelperText>
                ) : (
                  <FormHelperText className={classes.helperText}>
                    {''}
                  </FormHelperText>
                )}

                <Box className={classes.checkbox}>
                  <Checkbox
                    id={'authorized'}
                    name="authorized"
                    label={
                      <Typography>
                        {t('shipping-send-form:customs:authorized')}
                        <u onClick={() => setOpenModal(true)}>
                          {t('shipping-send-form:customs:custom-normative')}
                        </u>
                      </Typography>
                    }
                    checked={values.authorized}
                    onChange={onChange}
                    error={touched.wasSubmit && !values.authorized}
                  />
                </Box>
                <Box className={classes.checkbox}>
                  <Checkbox
                    id={'readed'}
                    name="readed"
                    label={
                      <Typography>
                        {t('shipping-send-form:customs:readed')}
                      </Typography>
                    }
                    checked={values.readed}
                    onChange={onChange}
                    error={touched.wasSubmit && !values.readed}
                  />
                </Box>
              </Box>
            </>
          ) : null}
        </>
      )}
    </FormLayout>
  )
}

StepCustoms.propTypes = {
  ...makeFormPropTypes(shippingSendCustomShipmentPropTypes),

  hasCustoms: PropTypes.bool,
}

export default StepCustoms
